<template>
    <div class="sort-by">
        <span class="label black--text">Sort by:</span>
        <v-select
                :items="priceOptions"
                label="Sort by"
                item-value="value"
                item-text="text"
                v-on:change="filter('setFilterSortByValue', $event)"
                flat
                solo
                dense
                v-model="priceOptionSelected"
                class="edu-border-select"
                hide-details
        >
            <template slot="append">
                    <span>
                        <v-icon size="18">mdi-chevron-down</v-icon>
                    </span>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        name: 'RoommateSortByFilter',
        data: () => ({
            priceOptionSelected:'photo',
            priceOptions: [
                {text: 'Newest First', value: 'newest'},
                {text: 'Profile Photo', value: 'photo'},
                {text: 'Earliest Start Date', value: 'startDate'},
            ],
        }),
        methods: {
            filter(type, value) {
                this.$store.commit(type, value);
                this.$store.dispatch('getMatchedRoommates');
            },
        }
    }
</script>

<style scoped>
    .sort-by {
        border-radius: 8px;
        border: 1px solid #d8d8d8;
        display: flex;
        align-items: center;
        padding-left: 12px;
        background: #fff;
        height: 40px;
    }

    .sort-by .label {
        white-space: nowrap;
        font-size: 14px;
        font-weight: 500;
        color: #1d1d1f;
    }

    .sort-by >>> .v-input {
        flex: 1;
    }

    .sort-by >>> .v-input__slot {
        background: transparent !important;
        padding: 0 8px !important;
        min-height: 38px !important;
    }

    .sort-by >>> .v-select__selection {
        font-size: 14px;
        font-weight: 400;
        color: #1d1d1f;
    }

    .sort-by >>> .v-input__append-inner {
        margin-top: 0 !important;
        align-self: center;
    }
</style>